import { includes } from "lodash-es";

import AppIcon from "@/common/components/Icons/AppIcon";
import { ROUTE_PATH } from "@/common/constants/routing";
import { EnvHelper } from "@/common/helpers/env";
import { useAuthorizationInfo } from "@/common/hooks/auth/useAuthorizationInfo";
import { useTenantProfileV2 } from "@/common/hooks/entity/tenant/useTenantProfileV2";
import { useAppHistory } from "@/common/hooks/routing/useAppHistory";
import { useMultiClick } from "@/common/hooks/useMultiClick";
import { TenantMode } from "@/core/api/generated/v1";

export function HeaderAppLogo() {
  const history = useAppHistory();
  const tenantProfile = useTenantProfileV2();
  const authorizationInfo = useAuthorizationInfo();

  // go to hidden dev area on 5 clicks
  const fiveClicks = useMultiClick({
    isEnabled:
      EnvHelper.isDevelopmentAny ||
      (EnvHelper.isProductionAny &&
        includes([TenantMode.Test, TenantMode.Demo], tenantProfile?.profile?.mode) &&
        authorizationInfo.hasAdminAppAccess),
    count: 5,
    delayMs: 1000,
    onMultiClick: () => {
      history.push(ROUTE_PATH.APP_AREA_DEV);
    },
  });

  return (
    <>
      {/* App logo */}
      <AppIcon
        sx={{
          display: { xxs: "none", xs: "initial", md: "none" },
          width: 20,
          height: 20,
          mr: 1,
        }}
        of='appLogo'
        onClick={fiveClicks.handleClick}
      />
      <AppIcon
        sx={{ display: { xxs: "none", md: "initial" }, width: 130, height: 20 }}
        of='appLogoFull'
        onClick={fiveClicks.handleClick}
      />

      {/* Logo as icon + text */}
      {/* <AppLogoIcon
              width='27'
              height='27'
              viewBox='0 0 27 27'
              sx={{ display: { xxs: "none", md: "block" } }}
            />
            <Typography
              component='div'
              variant='h5'
              sx={{
                display: { xxs: "none", md: "block" },
                color: (t) => t.palette.background.logo?.text,
                pl: 1,
                fontWeight: 500,
              }} // unknown color
            >
              Nexus
            </Typography>
            <Typography
              component='div'
              variant='h5'
              sx={{
                display: { xxs: "none", md: "block" },
                color: (t) => t.palette.background.logo?.text,
                fontWeight: 400,
              }} // unknown color
            >
              Fleet
            </Typography> */}
    </>
  );
}
